import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { ApiKeysPage } from './pages/ApiKeys';
import { EndUsersPage } from './pages/EndUsers';
import { LoginPage, SignupPage } from './pages/Auth';
import { MessageDetailPage } from './pages/MessageDetail';
import { MessagesPage } from './pages/Messages';
import { OverviewPage } from './pages/Overview';
import { ModerationSettingsPage } from './pages/ModerationSettings';
import { PoliciesPage } from './pages/Policies';
import { TeamPage } from './pages/Team';
import { WebhookPage } from './pages/Webhook';
import { DataRetentionPage } from './pages/DataRetention';

function RequireAuth() {
  const { me, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="boot"><Spinner /></div>;
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return <Layout />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route element={<RequireAuth />}>
        <Route index element={<OverviewPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="messages/:id" element={<MessageDetailPage />} />
        <Route path="end-users" element={<EndUsersPage />} />
        <Route path="settings" element={<Navigate to="/settings/moderation" replace />} />
        <Route path="settings/moderation" element={<ModerationSettingsPage />} />
        <Route path="settings/policies" element={<PoliciesPage />} />
        <Route path="settings/webhook" element={<WebhookPage />} />
        <Route path="settings/retention" element={<DataRetentionPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="keys" element={<ApiKeysPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
